import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"

// API existente de tipos de tarifa
const baseUrl = `${API_BASE_URL}/tipoTarifa`

/** Lista todos los tipos de tarifa. */
export const getTiposTarifa = async () => {
  const response = await authFetch(`${baseUrl}/listar`, { method: "GET" })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar los tipos de tarifa: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Crea un tipo de tarifa. Body: { nombre, horaInicio, horaFin } */
export const createTipoTarifa = async (data) => {
  const response = await authFetch(`${baseUrl}/crear`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al crear el tipo de tarifa: ${errorText || "Sin detalles"}`)
  }
  return { success: true }
}

/** Actualiza un tipo de tarifa. */
export const updateTipoTarifa = async (id, data) => {
  const response = await authFetch(`${baseUrl}/modificar/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al actualizar el tipo de tarifa: ${errorText || "Sin detalles"}`)
  }
  return { success: true }
}

/** Elimina un tipo de tarifa. */
export const deleteTipoTarifa = async (id) => {
  const response = await authFetch(`${baseUrl}/eliminar/${id}`, { method: "DELETE" })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al eliminar el tipo de tarifa: ${errorText || "Sin detalles"}`)
  }
  return { success: true }
}
